import React, { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as File } from "../../assets/svg/Reporting/fileSvg.svg";
import { ReactComponent as FileChart } from "../../assets/svg/Reporting/fileChart.svg";
import Sidebar from "../SideBar";
import HelpButton from "../../common/HelpButton";
import HelpPageModal from "../modals/HelpPageModal";

function ReportsHome() {
  const [helpModal, setHelpModal] = useState(false);
  const location = useLocation();

  const nationalHelpModal = location.pathname.includes("national");

  const menuList = [
    {
      name: "Извештавање",
      icon: null,
      subMenus: [
        {
          name: "Извештавање о прописима",
          title: "Извештавање о прописима",
          url: "/reporting/select-quarter/national",
          select: "/reporting/national/:id",
          icon: <File />,
        },
        {
          name: "Извештавање о мерама",
          title: "Извештавање о мерама",
          url: "/reporting/select-quarter/measures",
          select: "/reporting/measures/:id",
          icon: <FileChart />,
        },
      ],
    },
  ];

  return (
    <div className="w-full h-full flex flex-row relative ">
      {/* SIDEBAR */}
      <Sidebar menuList={menuList} />

      {/* OUTLET */}
      <div className="flex-1 w-full overflow-y-scroll gray-small-scroll transition-all duration-300">
        <Outlet />
      </div>
    </div>
  );
}

export default ReportsHome;
